
export const formatText = (
    text: string | number | boolean | null | undefined
): string => {
    if (text === null || text === undefined) return "N/A";
    const str = String(text);
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatAlltext = (text?: string | null): string => {
    if (!text?.trim()) return "-";
    return text
        .split(",")
        .map((word) =>
            word
                .trim()
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/\b\w/g, (l) => l.toUpperCase())
        )
        .join(", ");
};

export const formatWordArray = (arr?: string[] | null): string => {
    if (!arr || arr.length === 0) return "-";
    return arr
        .map((item) =>
            item
                .toLowerCase()
                .split("_")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")
        )
        .join(", ");
};


export const formatDate = (dateString: any) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
    });
};


export const formatCardType = (cardType: string): string => {
    if (!cardType) return '';

    const cardTypeMap: Record<string, string> = {
        'MARKETPLACECARD': 'Marketplace Card',
        
        'PROFILE': 'Profile',
        'ALL TYPES': 'All Types',
        'POST' : 'Post'
    };

    return cardTypeMap[cardType.toUpperCase()] || cardType;
};

export const formatCamelCaseText = (text: string): string => {
    if (!text) return '';
    if (['MARKETPLACECARDS', 'PROFILE', 'ALL TYPES'].includes(text.toUpperCase())) {
        return formatCardType(text);
    }

    return text
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')
        .replace(/(\d)([a-zA-Z])/g, '$1 $2')
        .replace(/^./, str => str.toUpperCase())
        .toLowerCase()
        .replace(/^\w/, c => c.toUpperCase())
        .trim();
};

export const formatDateTime = (dateString: string | undefined) => {

  const utcDate = new Date(`${dateString}Z`); 
  return utcDate.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};
